import { createReducer, on } from "@ngrx/store";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";
import { IBreeceSelectorDetails } from "../../models/breece-selector-details.interface";
import { BreeceSelectorState } from "../../models/state/app-state";
import { BreeceSelectorAction } from "./breece-selector.action";

export const BreeceSelectorsAdapter: EntityAdapter<IBreeceSelectorDetails> = createEntityAdapter<IBreeceSelectorDetails>();

export const initialState: BreeceSelectorState = BreeceSelectorsAdapter.getInitialState({
    isLoading: false,
    error: undefined,
});

export const breeceSelectorReducer = createReducer(
    initialState,
    on(BreeceSelectorAction.initialize, (state, { }) => {
        return state;
    }),
    on(BreeceSelectorAction.getBreceSelectorsFailed, (state) => ({ ...state, isLoading: true })),
    on(BreeceSelectorAction.getBreceSelectorsSuccess, (state, action) => {
        return BreeceSelectorsAdapter.addMany(action.enumDetails, {
            ...state,
            isLoading: false,
            error: undefined,
        });
    })
)




